<template>
  <div :class="['bar',{'bar__trangle':type==='trangle'},{'bar__dot':type==='dot'}]" :style="barStyle">
    <div v-if="!$slots.default" class="active-shape"></div>
    <div v-else class="slot-class">
        <!-- <svg-icon name="xiala"></svg-icon> -->
        <slot></slot>
    </div>
  </div>
</template>

<script>
// import SvgIcon from '@/components/public/SvgIcon.vue'
export default {
  props: {
    actIndex:{},
    // SvgIcon: {},
    activeTabClass:{
      default:'.activeTab'
    },
    type:{
      default:'trangle'
    }
    
  },
  data() {
    return {
      barStyle: {},
      actEl: null,
    };
  },

  // computed:{
  //    barStyle(){
  //     //   debugger
  //     //    await this.$nextTick(()=>{
  //           this.actEl =  document.querySelector('.activeTab')
  //         // })
  //   console.log("🚀 ~  this.actEl",  this.actEl)
  // //   this.actIndex
  //   console.log("🚀 ~ this.actIndex", this.actIndex)

  //   debugger

  //         return {
  //             width:`${this.actEl&&this.actEl.clientWidth}px`,
  //             transform: `translateX(${this.actEl&&this.actEl.offsetLeft}px)`
  //         }

  //     }
  // },
//   watch: {
//     actIndex: {
//       handler() {
//         this.actEl = document.querySelector(".activeTab");
//         if (!this.actEl) handler();
//         this.barStyle = {
//           width: `${this.actEl && this.actEl.clientWidth}px`,
//           transform: `translateX(${this.actEl && this.actEl.offsetLeft}px)`,
//         };
//       },
//       immediate: true,
//     },
//   },
  mounted() {
    //console.log("🚀 ~ this", this)
    // this
    this.actEl = document.querySelector(this.activeTabClass);
    this.$watch(
      "actIndex",
      function () {
        console.log("========sssss",this.activeTabClass);
        this.actEl = document.querySelector(this.activeTabClass);
        this.barStyle = {
          width: `${this.actEl && this.actEl.clientWidth -48}px`,
          transform: `translateX(${this.actEl && this.actEl.offsetLeft}px)`,
         '-ms-transform': `translateX(${this.actEl && this.actEl.offsetLeft}px)`
        };
      },
      { immediate: true }
    );
    // debugger
    //   this.actEl =  document.querySelector('.activeTab')
    // this.$parent.$refs['tab']
    // console.log("🚀 ~ this.$parent.$refs['tab']",this.actEl )
  },
};
</script>

<style lang="scss" scoped>
.slot-class{
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      line-height: initial;
}
.bar { 
  position: absolute;
  bottom: 0;
  left:0;
  transition: all 0.3s ease-in-out;
}
.bar.bar__dot{
  // position: relative;
        &::after {
          content: "";
          width: 6px;
          height: 6px;
          background: #ffffff;
          border-radius: 50%;
          position: absolute;
          bottom: 10px;
          left: 50%;
          transform: translateX(-50%);
        }
}
.bar.bar__trangle{
  background-color: rgba(46, 94, 185, 1);
  border-radius: 3px;
  //width: 40px;
  height: 5px;
  //width: 10% !important;
  left: 25px;
  .active-shape {
    position: absolute;
    content: "";
    // width: 0;
    // height: 0;
    // border-left: 10px solid transparent;
    // border-right: 10px solid transparent;
    // border-bottom: 13px solid #004fb1;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  //   -ms-transform: translateX(-50%);
  }
}

</style>


// WEBPACK FOOTER //
// src/components/reception/indexPage/TabTrangle.vue